function useQuestionNumber(watch, sectionIndex, index) {
  const sections = watch('sections');
  const prevSections = sections.slice(0, sectionIndex);
  const questionsSoFar = prevSections.map((section) => section.questions).flat();
  const questionNumber = questionsSoFar.length + index + 1;
  return { questionNumber };
}

export { useQuestionNumber };
